import React from "react";

const scrollToSection = (id) => {
  if (id === "top") {
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }

  const target = document.getElementById(id);
  if (!target) return;

  const nav = document.querySelector(".site-nav");
  const navHeight = nav ? nav.getBoundingClientRect().height : 0;
  const extraSpace = 0;
  const targetTop =
    target.getBoundingClientRect().top +
    window.pageYOffset -
    navHeight -
    extraSpace;

  window.scrollTo({
    top: Math.max(targetTop, 0),
    behavior: "smooth",
  });
};

const Header = () => {
  return (
    <header className="site-nav">
      <button
        type="button"
        className="site-nav__brand site-nav__brand-btn"
        onClick={() => scrollToSection("top")}
      >
        Hassan Zahar Rifat
      </button>
      <ul className="site-nav__links">
        <li>
          <button
            type="button"
            className="site-nav__link-btn"
            onClick={() => scrollToSection("professional-arc")}
          >
            Work
          </button>
        </li>
        <li>
          <button
            type="button"
            className="site-nav__link-btn"
            onClick={() => scrollToSection("open-source")}
          >
            <span className="site-nav__label--full">Open Source</span>
            <span className="site-nav__label--short">OSS</span>
          </button>
        </li>
        <li>
          <button
            type="button"
            className="site-nav__link-btn"
            onClick={() => scrollToSection("projects")}
          >
            Side
          </button>
        </li>
        <li>
          <button
            type="button"
            className="site-nav__link-btn"
            onClick={() => scrollToSection("blogs")}
          >
            Writing
          </button>
        </li>
        <li>
          <button
            type="button"
            className="site-nav__link-btn"
            onClick={() => scrollToSection("about")}
          >
            About
          </button>
        </li>
        <li>
          <button
            type="button"
            className="site-nav__link-btn"
            onClick={() => scrollToSection("contact")}
          >
            Contact
          </button>
        </li>
      </ul>
      <a className="site-nav__email" href="mailto:hz.rifat@gmail.com">
        hz.rifat@gmail.com
      </a>
    </header>
  );
};

export default Header;
